import React from 'react';
import { MatterInfoHeader } from '../MatterInfoHeader';

type SidebarHeaderProps = {
  matterName: string;
  matterId?: number;
  clioMatterId?: string;
};

export const SidebarHeader = ({
  matterName,
  matterId,
  clioMatterId,
}: SidebarHeaderProps) => {
  return (
    <MatterInfoHeader
      matterId={matterId}
      clioMatterId={clioMatterId}
      fallbackMatterName={matterName}
    />
  );
};
